import { Link } from "react-router-dom";
import { usePageMeta } from "@/hooks/usePageMeta";

export default function CookiesPage() {
  usePageMeta(
    "Politica Cookies - Ordell WebCare",
    "Informații despre cookie-urile utilizate pe site-ul Ordell WebCare și cum le puteți gestiona."
  );

  return (
    <section data-testid="cookies-page" className="py-16 lg:py-24">
      <div className="section-container max-w-3xl">
        <h1 className="font-['Outfit'] text-4xl sm:text-5xl tracking-tighter leading-none font-bold text-[#1A1D20] mb-8">
          Politica cookies
        </h1>
        <p className="text-xs text-[#64748B] mb-8">Ultima actualizare: Decembrie 2025</p>

        <div className="prose prose-sm max-w-none space-y-6 text-[#4A5568] leading-relaxed">
          <h2 className="font-['Outfit'] text-xl font-semibold text-[#1A1D20]">1. Ce sunt cookie-urile?</h2>
          <p>
            Cookie-urile sunt fișiere text de mici dimensiuni care sunt stocate pe dispozitivul dumneavoastră atunci când vizitați un site web. Acestea sunt utilizate pe scară largă pentru a face site-urile web să funcționeze mai eficient și pentru a furniza informații proprietarilor site-ului.
          </p>

          <h2 className="font-['Outfit'] text-xl font-semibold text-[#1A1D20] !mt-8">2. Cookie-uri utilizate</h2>
          <p>Site-ul Ordell WebCare poate utiliza următoarele tipuri de cookie-uri:</p>
          <ul className="list-disc pl-5 space-y-2">
            <li><strong>Cookie-uri strict necesare:</strong> esențiale pentru funcționarea site-ului și nu pot fi dezactivate.</li>
            <li><strong>Cookie-uri de performanta:</strong> colectează informații anonime despre modul în care vizitatorii utilizează site-ul, pentru a ne ajuta să îl îmbunătățim.</li>
            <li><strong>Cookie-uri functionale:</strong> permit site-ului să rețină alegerile făcute de dumneavoastră pentru a oferi o experiență personalizată.</li>
          </ul>

          <h2 className="font-['Outfit'] text-xl font-semibold text-[#1A1D20] !mt-8">3. Gestionarea cookie-urilor</h2>
          <p>
            Puteți controla și gestiona cookie-urile prin setările browser-ului dumneavoastră. Majoritatea browserelor vă permit să refuzați sau să acceptați cookie-uri, să ștergeți cookie-urile existente și să setați preferințe pentru anumite site-uri.
          </p>

          <h2 className="font-['Outfit'] text-xl font-semibold text-[#1A1D20] !mt-8">4. Cookie-uri terte</h2>
          <p>
            Site-ul nostru poate utiliza servicii terțe (precum Google Analytics) care pot seta propriile cookie-uri. Nu avem control asupra acestor cookie-uri și vă recomandăm să consultați politicile de confidențialitate ale acestor servicii.
          </p>

          <h2 className="font-['Outfit'] text-xl font-semibold text-[#1A1D20] !mt-8">5. Modificari</h2>
          <p>
            Ne rezervăm dreptul de a actualiza această politică. Orice modificări vor fi publicate pe această pagină cu data ultimei actualizări.
          </p>

          <h2 className="font-['Outfit'] text-xl font-semibold text-[#1A1D20] !mt-8">6. Contact</h2>
          <p>
            Pentru întrebări legate de utilizarea cookie-urilor, ne puteți contacta prin formularul de contact disponibil pe site.
          </p>
          <p className="text-sm"><strong>Operator:</strong> SC Maze Digital SRL, CUI: RO38272886</p>
        </div>

        <div className="mt-12">
          <Link to="/" className="text-sm font-medium text-[#0F2942] hover:text-[#0F2942]/80 transition-colors">
            &larr; Înapoi la pagina principală
          </Link>
        </div>
      </div>
    </section>
  );
}
